import { jsx, css } from '@emotion/react';

import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import useTheme from '../hooks/useTheme';
import { StyleObjectWithTheme } from '@/core/App/theme';

function Popup(props: any) {
  const {
    message,
    action,
    button,
    toggleVisibility,
    visible: isVisible,
  } = props;

  const theme = useTheme();
  const styles = stylesheet(theme);

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isVisible}
      autoHideDuration={600000}
    >
      <SnackbarContent
        css={styles.snackbarContent}
        message={<span css={styles.message}>{message}</span>}
        action={[
          <Button
            key="refresh"
            variant="contained"
            color="primary"
            size="small"
            css={styles.button}
            onClick={action}
          >
            {button || 'Action'}
          </Button>,

          <Button
            key="close"
            color="primary"
            size="small"
            css={styles.close}
            onClick={toggleVisibility}
          >
            HIDE
          </Button>,
        ]}
      />
    </Snackbar>
  );
}

const stylesheet: StyleObjectWithTheme = (theme) => ({
  close: {
    height: '100%',
    width: 'auto',
    color: '#47AAE5',
  },

  snackbarContent: {
    backgroundColor: 'white',
    maxWidth: 'initial',
  },

  message: {
    color: 'black',
  },

  icon: {
    color: 'black',
  },

  button: {
    marginRight: '0.5rem',
    '& span': {
      lineHeight: '1rem',
    },
  },
});

export default Popup;
